import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom"; 
import { useSelector, useDispatch } from 'react-redux';
import {
  AppBar, Toolbar, Typography, Drawer, Box, Select, MenuItem, Stack,
  FormControl, TextField, InputLabel, Button, IconButton,
  Grid, Tabs, Tab, ButtonGroup, Menu,
  List, ListItem, ListItemText, ListItemAvatar, ListItemButton,
  DialogTitle, Dialog, DialogContent, DialogActions, DialogContentText,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CircularProgress from '@mui/material/CircularProgress';
import TopicIcon from '@mui/icons-material/Topic';
import { set } from 'lodash';

const { fpzActions, emailActions } = require('../../actions');


const Header = ({
  title = "",
  ActionButtons = () => (<></>),
  print = false,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const authState = useSelector(state => state.authReducer);
  const fpzState = useSelector(state => state.fpzReducer);
  const userState = useSelector(state => state.userReducer);

  const [printAnchorEl, setPrintAnchorEl] = useState(null);
  const [accountAnchorEl, setAccountAnchorEl] = useState(null);

  const [open, setOpen] = React.useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogContent, setDialogContent] = useState('');
  const [dialogContentText, setDialogContentText] = useState('');
  const [dialogActions, setDialogActions] = useState(null);

  // save
  const saveReportRef = useRef({
    report_name: fpzState?.report_name || '',
    report_description: fpzState?.report_description || '',
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  const handleMenuClick = (event, anchor) => {
    switch (anchor) {
      case 'print':
        setPrintAnchorEl(event.currentTarget);
        break;
      case 'account':
        setAccountAnchorEl(event.currentTarget);
        break;
      default:
        console.error('Unknown menu anchor:', anchor);
    }
  };

  const handleMenuClose = (action) => {
    setPrintAnchorEl(null);
    setAccountAnchorEl(null);
    if (action) action();
  };

  const handlePrintReport = () => {
    // check that there is at least one verified offset well
    
    console.log('/print');
    window.print();
  };

  const handleExport = () => {
    console.log('handleExport');
  };

  const handleSaveForm = () => {
    console.log('handleSaveForm', saveReportRef.current);
    let fpzReportId = fpzState?.fpz_report_id || null;

    setDialogTitle('Save Report');
    setDialogContentText('Save your report to the FPZ database.');
    setDialogContent(
      <>
        <TextField
          autoFocus
          margin="dense"
          label="Report Name"
          type="text"
          fullWidth
          variant="outlined"
          onChange={(e) => handleChangeSaveForm('report_name', e.target.value)}
          defaultValue={saveReportRef?.current?.report_name || ''}
        />
        <TextField
          margin="dense"
          label="Report Description"
          fullWidth
          variant="outlined"
          multiline
          rows={4}
          maxRows={4}
          onChange={(e) => handleChangeSaveForm('report_description', e.target.value)}
          defaultValue={saveReportRef?.current?.report_description || ''}
        />
      </>
    );
    setDialogActions(
      <>
        <Button onClick={handleSaveReport}>Save</Button>
      </>
    );
    handleClickOpen();
  };

  const handleShare = (emailRecipient =  null) => {
    console.log('handleShare', saveReportRef.current);
    let fpzReportId = fpzState?.fpz_report_id || null;

    handleChangeSaveForm('email_recipient', emailRecipient);
    setDialogTitle('Send Report to Abra');
    setDialogContentText('The report will be saved to your account and sent to Abra.');
    setDialogContent(
      <>
        <TextField
          autoFocus
          margin="dense"
          label="Report Name"
          type="text"
          fullWidth
          variant="outlined"
          onChange={(e) => handleChangeSaveForm('report_name', e.target.value)}
          defaultValue={saveReportRef?.current?.report_name || ''}
        />
        <TextField
          margin="dense"
          label="Report Description"
          fullWidth
          variant="outlined"
          multiline
          rows={4}
          maxRows={4}
          onChange={(e) => handleChangeSaveForm('report_description', e.target.value)}
          defaultValue={saveReportRef?.current?.report_description || ''}
        />
      </>
    );
    setDialogActions(
      <>
        <Button onClick={() => handleSaveReport({ isShare: true })}>Send</Button>
      </>
    );
    handleClickOpen();
  };

  const handleChangeSaveForm = (key, value) => {
    saveReportRef.current = {
      ...saveReportRef.current,
      [key]: value.trim(),
    };
    console.log('handleChangeSaveForm', key, value, saveReportRef.current);
  }
  
  const handleSaveReport = async ({ isShare = false } = {}) => {
    setDialogActions(<CircularProgress />);

    let fpzReportId = fpzState?.fpz_report_id || null;
    const params = {
      ...saveReportRef.current,
      user_id: authState?.profile?.userId,
      report_details: {
        boundingBox: fpzState?.boundingBox,
        map: fpzState?.map,
        selectedTreatmentWells: fpzState?.selectedTreatmentWells,
        filter: fpzState?.filter,
        contacts: fpzState?.contacts,
        reportImages: fpzState?.reportImages,
      },
    }
    console.log('handleSaveReport', params);
    let response = null;
    if (!fpzReportId) {
      response = await fpzActions.createFpzReport(params);
    } else {
      params.fpz_report_id = fpzReportId;
      response = await fpzActions.updateFpzReport(params);
    }
    console.log('handleSaveReport response', response);
    if (response?.success) {
      
      // Email report if isShare is true
      if (isShare) {
        // call backend to email report 
        const emailParams = {
          fpz_report_id: response.fpz_report_id,
          user_id: authState?.profile?.userId,
          email_recipient: saveReportRef?.current?.email_recipient,
          report_name: saveReportRef?.current?.report_name,
          report_description: saveReportRef?.current?.report_description,
          user_email: userState?.user?.user_email,
          user_first_name: userState?.user?.user_first_name,
          user_last_name: userState?.user?.user_last_name,
          sender_name: `${userState?.user?.user_first_name || ''} ${userState?.user?.user_last_name || ''}`.trim(),
          sender_email: userState?.user?.user_email,
          report_url: `${window.location.origin}/report/${response.fpz_report_id}`,
        };
        const emailResponse = await emailActions.sendEmail(emailParams);
        console.log('Email report response', emailResponse);
        //if (emailResponse?.success) {
          setDialogContentText('');
          setDialogContent('Report saved and emailed successfully.');
          setDialogActions(null);
        //}

      } else {

          // show response
        setDialogContentText('');
        setDialogContent('Report saved successfully.');
        setDialogActions(null);

      }

      

      setTimeout(() => {
        handleClose();
      }, 1500);
      
    } else {
      setDialogActions(
        <>
          <Button onClick={() => handleSaveReport({ isShare: true })}>Send</Button>
          <span style={{ color: 'red' }}>{response?.message || 'Error saving report'}</span>
        </>
      );
    }
    
  }

  return (
    <>
      {/* Top Navbar */ }
      <AppBar position="absolute" sx={{ zIndex: 10 }}>
        <Toolbar sx={{ width: '100%' }}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="h6">
                Abra Controls Directive 83 
                {title && title.length > 0 ? ' - ' : ''}
                {title}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Stack className="no-print" direction="row" spacing={2} justifyContent="flex-end" p={2}>
                <ActionButtons />
                {print && (
                  <ButtonGroup variant="contained" color="info">
                    <Button
                      onClick={handlePrintReport}
                    >
                      Print
                    </Button>
                    <Button
                      size="small"
                      onClick={(event) => { handleMenuClick(event, 'print') }}
                    >
                      <ArrowDropDownIcon />
                    </Button>
                    <Menu
                      anchorEl={printAnchorEl}
                      open={Boolean(printAnchorEl)}
                      onClose={() => handleMenuClose()}
                    >
                      <MenuItem onClick={() => handleMenuClose(handleSaveForm)}>Save</MenuItem>
                      { /*<MenuItem onClick={() => handleMenuClose(handleExport)}>Export</MenuItem>*/ }
                      <MenuItem onClick={() => handleMenuClose(handleShare('roger.rigsby@abracontrols.com'))}>Send to Abra</MenuItem>
                    </Menu>
                  </ButtonGroup>
                )}
                { (fpzState?.selectedTreatmentWells?.length > 0 || title === "Profile") && (
                  <>
                    <Button
                      onClick={() => {
                        if (fpzState?.selectedTreatmentWells?.length > 0) {
                          if (window.confirm('Are you sure you want to create a new FPZ report? This will clear the current FPZ data.')) {
                            dispatch({ type: 'CLEAR_FPZ' });
                            navigate('/app');
                          }
                        } else {
                          dispatch({ type: 'CLEAR_FPZ' });
                          navigate('/app');
                        }
                      }}
                      title="Create New FPZ Report"
                      variant="contained"
                    >
                      New 
                      <AddBoxIcon sx={{ color: 'white' }} />
                    </Button>
                    <Button
                      onClick={() => {
                        if (fpzState?.selectedTreatmentWells?.length > 0) {
                          if (window.confirm('Are you sure you want to create a new FPZ report? This will clear the current FPZ data.')) {
                            dispatch({ type: 'CLEAR_FPZ' });
                            navigate('/app');
                          }
                        } else {
                          dispatch({ type: 'CLEAR_FPZ' });
                          navigate('/app');
                        }
                      }}
                      title="Create New FPZ Report"
                      variant="contained"
                    >
                      Reports 
                      <TopicIcon sx={{ color: 'white' }} />
                    </Button>
                  </>
                )}
                {
                  authState?.authenticated ?
                    <>
                      <IconButton
                        onClick={(event) => { handleMenuClick(event, 'account') }}
                      >
                        <PersonIcon sx={{ color: 'white' }} />
                        <Box
                          component="span"
                            sx={{
                            fontSize: '1rem',
                            color: 'white',
                            display: {
                              // xs: 'none',
                              sm: 'inline'
                            }
                            }}
                        >
                          { userState?.user?.user_first_name || ''}
                        </Box>
                      </IconButton>
                      <Menu
                        anchorEl={accountAnchorEl}
                        open={Boolean(accountAnchorEl)}
                        onClose={() => handleMenuClose()}
                      >
                        <MenuItem onClick={() => navigate('/app/account/profile') }>Profile</MenuItem>
                        <MenuItem onClick={() => { dispatch({type: 'LOGOUT' }); navigate('/'); }}>Sign out</MenuItem>
                      </Menu>
                    </>
                  : <IconButton
                      onClick={() => navigate('/login')}
                      title="Sign In"
                    >
                      <PersonOutlineOutlinedIcon sx={{ color: 'white' }} />
                      <Box
                        component="span"
                          sx={{
                          fontSize: '1rem',
                          color: 'white',
                          display: {
                            xs: 'none',
                            sm: 'inline'
                          }
                          }}
                      >
                        Sign In
                      </Box>
                    </IconButton>
                  
                }
              </Stack>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>
          {dialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {dialogContentText}
          </DialogContentText>
          {dialogContent}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          {dialogActions}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Header;
